import { DialogRef } from '@angular/cdk/dialog'

import { Component, ChangeDetectionStrategy, Inject, ViewEncapsulation } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { FlagsService } from '@services/flags/flags.service'
import { ConfirmDialogButton, ConfirmDialogData } from './confirm-dialog.type'

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss', '../../../../styles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [MatCheckboxModule, MatDialogModule, FormsModule, TranslateModule]
})
export class ConfirmDialogComponent {
  public title: ConfirmDialogData['title']
  public message: ConfirmDialogData['message']
  public dontShowAgainFlag: ConfirmDialogData['dontShowAgainFlag']
  public buttons: ConfirmDialogData['buttons']
  public dontShowAgain = false

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private readonly dialogRef: DialogRef,
    private readonly translateService: TranslateService,
    private readonly flagsService: FlagsService
  ) {
    this.title = this.data.title || this.translateService.instant('CONFIRM_DIALOG.TITLE')
    this.message = this.data.message
    this.dontShowAgainFlag = this.data.dontShowAgainFlag
    this.buttons = this.data.buttons || [
      { text: this.translateService.instant('CONFIRM_DIALOG.YES'), exec: () => true },
      { text: this.translateService.instant('CONFIRM_DIALOG.NO'), primary: true, exec: () => false }
    ]

    if (this.dontShowAgainFlag) {
      this.dontShowAgain = this.flagsService.getFlag(this.dontShowAgainFlag)
    }
  }

  public async onButtonClick(button: ConfirmDialogButton): Promise<void> {
    if (this.dontShowAgainFlag) {
      this.flagsService.setFlag(this.dontShowAgainFlag, this.dontShowAgain)
    }

    if (!button.exec) {
      this.dialogRef.close(false)
      return
    }

    const result = await button.exec()

    this.dialogRef.close(result)
  }

  public trackByFn(index: number): number {
    return index
  }
}
